export default __webpack_public_path__ + "static/bigleaf-957aabb7841e455369d3420ad9dc5ab7.png";